module.exports = __webpack_public_path__ + "static/media/v_empty_challenge_list.48386194.jpg";